import { faFileCircleInfo } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon as Icon } from "@fortawesome/react-fontawesome";
import cn from "classnames";

import styles from "./FileCard.module.scss";

import type { FunctionComponent } from "react";
import type { FileCard_file$data } from "__generated__/FileCard_file.graphql";
import type { Size } from "./FileCard";

export const RtkFileCard: FunctionComponent<{
  file: FileCard_file$data;
  size?: Size;
  readonly?: boolean;
  selecting?: boolean;
  selected?: boolean;
  cantDeselect?: boolean;
  handleCheckboxChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onClick?: () => void;
}> = ({
  file,
  size,
  readonly = true,
  selecting = false,
  selected = false,
  cantDeselect = false,
  handleCheckboxChange,
  onClick,
}) => {
  const fileKindText = file.kind;
  const fileSuffix = file.filename.split(".").pop();

  return (
    <div
      className={cn(
        "bg-gray-100 dark:bg-gray",
        "shadow-[0_0_8px_2px] shadow-gray-300 dark:shadow-gray",
        "hover:shadow-cardHover dark:hover:shadow-cardHover",
        "flex flex-col items-center justify-center",
        "relative"
      )}
      style={{
        ...size,
        cursor: onClick ? "pointer" : "auto",
      }}
      onClick={onClick}
    >
      {fileKindText && (
        <div
          className={cn(
            "absolute bottom-2 right-2",
            "bg-black dark:bg-gray-100",
            "text-white dark:text-black",
            "rounded",
            "text-center text-sm",
            "px-1.5",
            "uppercase"
          )}
        >
          {fileSuffix}
        </div>
      )}
      {file && (
        <Icon icon={faFileCircleInfo} className={cn("text-black dark:text-white", "h-10")} />
      )}
      {!readonly && (
        <input
          className={cn(selecting ? styles.selectedCheckbox : styles.hoverableCheckbox)}
          type="checkbox"
          checked={selected}
          onChange={handleCheckboxChange}
          disabled={selected && cantDeselect}
        />
      )}
    </div>
  );
};
